import type { Position } from 'geojson';

export const TEST_ID = 'map';

export const DEFAULT_MAX_ZOOM = 20;

export const DEFAULT_MIN_ZOOM = 4.5;

export const DEFAULT_ZOOM = 10;

export const DEFAULT_CENTER: Position = [-98.5795, 39.8283];

export const MAP_STYLE = 'mapbox://styles/mapbox/standard-satellite';

export enum OutlineMode {
    BOUNDING_BOX = 'boundingBox',
    GEOMETRY_OUTLINE = 'geometryOutline'
}

export enum DRAWING_TOOL {
    POLYGON = 'polygon',
    CIRCLE = 'circle'
}

export enum DRAWING_MODE {
    APPLY = 'apply',
    NO_ENTRY = 'noEntry'
}

export enum POINT_MODE {
    RETICLE = 'reticle',
    TOUCH = 'touch'
}

export enum MAP_LAYER {
    DRAWING_BOUNDARY_POLYGON_FILL = 'drawing-boundary-polygon-fill',
    DRAWING_BOUNDARY_POLYGON_CURRENT_VERTEX_LINE = 'drawing-boundary-polygon-current-vertex-line',
    DRAWING_BOUNDARY_POLYGON_FIRST_TO_LAST_LINE = 'drawing-boundary-polygon-first-to-last-line',
    DRAWING_BOUNDARY_POLYGON_OUTLINE = 'drawing-boundary-polygon-outline',
    DRAWING_BOUNDARY_POLYGON_NEXT_POINT_LINE = 'drawing-boundary-polygon-next-point-line',
    DRAWING_POINT = 'drawing-point',
    DRAWING_BOUNDARY_CIRCLE_FILL = 'drawing-boundary-circle-fill',
    DRAWING_BOUNDARY_CIRCLE_OUTLINE = 'drawing-boundary-circle-outline',
    DRAWING_CIRCLE_RADIUS_LINE = 'drawing-circle-radius-line',
    DRAWING_BOUNDING_BOX_OUTLINE = 'drawing-bounding-box-outline',
    DRAWING_OBSTACLE_BOUNDING_BOX_OUTLINE = 'drawing-obstacle-bounding-box-outline',

    COMPLETED_BOUNDARY_FILL = 'completed-boundary-fill',
    COMPLETED_OBSTACLE_FILL = 'completed-obstacle-fill',

    STATIC_BOUNDARY_FILL = 'static-boundary-fill',
    STATIC_BOUNDARY_OUTLINE = 'static-boundary-outline',
    STATIC_BOUNDARY_OUTLINE_MODIFIED = 'static-boundary-outline-modified',
    STATIC_OBSTACLE_FILL = 'static-obstacle-fill',
    STATIC_BOUNDING_BOX_OUTLINE = 'static-bounding-box-outline',
    STATIC_OBSTACLE_BOUNDING_BOX_OUTLINE = 'static-obstacle-bounding-box-outline',

    DRAWING_OBSTACLE_POLYGON_FILL = 'drawing-obstacle-polygon-fill',
    DRAWING_OBSTACLE_POLYGON_OUTLINE = 'drawing-obstacle-polygon-outline',
    DRAWING_OBSTACLE_POLYGON_CURRENT_VERTEX_LINE = 'drawing-obstacle-polygon-current-vertex-line',
    DRAWING_OBSTACLE_POLYGON_FIRST_TO_LAST_LINE = 'drawing-obstacle-polygon-first-to-last-line',
    DRAWING_OBSTACLE_CIRCLE_FILL = 'drawing-obstacle-circle-fill',
    DRAWING_OBSTACLE_CIRCLE_OUTLINE = 'drawing-obstacle-circle-outline',

    RETICLE_CENTER_POINT = 'reticle-center-point',
    RETICLE_INNER_CIRCLE_PERIMETER = 'reticle-inner-circle-perimeter',
    RETICLE_OUTER_CIRCLE_PERIMETER = 'reticle-outer-circle-perimeter',

    CLUSTER = 'clusters',
    CLUSTER_COUNT = 'cluster-count',
    UNCLUSTERED_POINT = 'unclustered-point',
    UNCLUSTERED_COUNT = 'unclustered-count',

    FLIGHT_PATH_LINE = 'flight-path-line',
    FLIGHT_PATH_FILL = 'flight-path-fill',
    FLIGHT_PATH_HIGHLIGHT_LINE = 'flight-path-highlight-line',
    FLIGHT_PATH_HIGHLIGHT_FILL = 'flight-path-highlight-fill',

    PRESCRIPTION_ZONES_FILL = 'prescription-zones-fill'
}

export const CLICKABLE_LAYERS = [
    MAP_LAYER.DRAWING_POINT,
    MAP_LAYER.CLUSTER,
    MAP_LAYER.CLUSTER_COUNT,
    MAP_LAYER.UNCLUSTERED_POINT,
    MAP_LAYER.UNCLUSTERED_COUNT,
    MAP_LAYER.COMPLETED_BOUNDARY_FILL,
    MAP_LAYER.COMPLETED_OBSTACLE_FILL
];

export const COMPLETED_LAYER_BY_MODE: Record<DRAWING_MODE, MAP_LAYER> = {
    [DRAWING_MODE.APPLY]: MAP_LAYER.COMPLETED_BOUNDARY_FILL,
    [DRAWING_MODE.NO_ENTRY]: MAP_LAYER.COMPLETED_OBSTACLE_FILL
};
